export const QR_COUNTRIES = {
  ARGENTINA: 'AR',
  CHILE: 'CL',
}

export const normalizeQrCountry = (value) => {
  const normalizedValue = String(value || '').trim().toUpperCase()
  if (normalizedValue === 'CL' || normalizedValue === 'CHILE') {
    return QR_COUNTRIES.CHILE
  }
  return QR_COUNTRIES.ARGENTINA
}

export const getQrCountryFromSearch = (search) => {
  try {
    return normalizeQrCountry(new URLSearchParams(search).get('country'))
  } catch (_err) {
    return QR_COUNTRIES.ARGENTINA
  }
}

export const getQrLoginUrl = ({ appDomain, code, country }) => {
  const baseUrl = `${appDomain}/qr-login?code=${code}`
  return normalizeQrCountry(country) === QR_COUNTRIES.CHILE
    ? `${baseUrl}&country=${QR_COUNTRIES.CHILE}`
    : baseUrl
}
